var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('div',{staticClass:"main-container"},[(this.$route.query.mode !== 'iframe')?_c('Navbar'):_vm._e(),_vm._t("default"),(this.$route.query.mode !== 'iframe')?_c('Footer'):_vm._e()],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }